import * as types from '../constants/adminConstants';
import * as api from '../../api/api';

export function getAddressUpdateDetails(logId) {
	return function (dispatch) {
		dispatch({ type: types.GET_ADDRESS_UPDATE_DETAILS });

		api.get(`admin/addressupdate/${logId}`)
			.then(function (response) {
				dispatch(getAddressUpdateDetailsSuccess(response));
			}).catch(function (error) {
				dispatch(getAddressUpdateDetailsFailure(error));
			});
	};
}

export function getAddressUpdateDetailsSuccess(response) {
	return {
		type: types.GET_ADDRESS_UPDATE_DETAILS_SUCCESS,
		response: response
	};
}

export function getAddressUpdateDetailsFailure(error) {
	return {
		type: types.GET_ADDRESS_UPDATE_DETAILS_FAILURE,
		error: error
	};
}

export function approveAddress(logId, data) {
	return function(dispatch) {
		dispatch({ type: types.APPROVE_ADDRESS });

		api.put(`admin/addressupdate/${logId}`, data)
				.then(function (response) {
					dispatch(approveAddressSuccess(response));
				}).catch(function (error) {
					dispatch(approveAddressFailure(error));
				});
	};
}

export function approveAddressSuccess(response) {
	return {
		type: types.APPROVE_ADDRESS_SUCCESS,
		response: response
	};
}

export function approveAddressFailure(error) {
	return {
		type: types.APPROVE_ADDRESS_FAILURE,
		error: error
	};
}


// WEBPACK FOOTER //
// ./app/admin/actions/adminActions.js